<template>
  <div id="app">
<myheader ></myheader>
    <router-view />
<myfooter ></myfooter>

  </div>
</template>

<script>
import {mapGetters, mapActions, mapMutations} from 'vuex';
import myheader from "./components/myheader"
import myfooter from "./components/myfooter"



export default {
  name: 'App',

components:{
  myheader,
  myfooter
},
data() {
      return {


        }
    },

computed:{
  ...mapGetters([

  ]),


},
methods:{
  ...mapMutations([

  ]),
  ...mapActions([
  
  ]),

},

mounted(){

}

}
</script>

<style >
/* @import "static/style.css"; */
#app {
  /* background-image: url('./assets/avi.jpg'); */
  /* background-size: cover; */
  /* opacity: 0.7; */
  /* margin: 0 0;
  background-blend-mode:screen;
   background-repeat: no-repeat;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center; */
  /* background: linear-gradient(green, blue); */

}
</style>



// WEBPACK FOOTER //
// src/App.vue